import React from 'react';
import { bool, shape, string } from 'prop-types';

const FilterList = ({
  className = '',
  notUseClass = false,
  style = {},
}) => (
  <svg className={notUseClass ? '' : className} style={style} width="1em" height="1em" viewBox="0 0 18 18" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M2.25 4.5V6H15.75V4.5H2.25ZM7.5 13.5H10.5V12H7.5V13.5ZM13.5 9.75H4.5V8.25H13.5V9.75Z" fill="currentColor" />

  </svg>
);

FilterList.propTypes = {
  className: string,
  notUseClass: bool,
  style: shape({}),
};

export default FilterList;
